import { IAPILinkedMediaModel, IAPIMediaGridModel } from "../interfaces/IAPIMediaModels";

export class MediaModel {
    fullURL: string;
    mediaId: string;
    s3Key: string;
    type: string;
    isFavourite?: boolean;
    constructor(data?: Partial<MediaModel>) {
        this.fullURL = data?.fullURL || '';
        this.mediaId = data?.mediaId || '';
        this.s3Key = data?.s3Key || '';
        this.type = data?.type || '';
        this.isFavourite = data?.isFavourite || false;
    }

    isImage() {
        return this.type?.toLowerCase() === 'image';
    }

    static deserializeAPIModel(data: IAPILinkedMediaModel): MediaModel {
        const mappedData: Partial<MediaModel> = {
            fullURL: data.fullURL || '',
            mediaId: data.mediaId || '',
            s3Key: data.s3Key,
            type: data.type,
            isFavourite: data.isFavourite || false,
        };
        return new MediaModel(mappedData);
    }

    createAPIModel(): IAPILinkedMediaModel {
        return {
            fullURL: this.fullURL,
            mediaId: this.mediaId || null,
            s3Key: this.s3Key,
            type: this.type,
            isFavourite: this.isFavourite || false,
        };
    }

    static fromMediaGridResponseModel(media: MediaGridResponseModel): MediaModel {
        return new MediaModel({
            fullURL: media.url,
            mediaId: media.id,
            s3Key: media.s3Key,
            type: media.type,
        });
    }

    validate(): boolean {
        return this.mediaId?.length > 0 || this.fullURL?.length > 0;
    }
}

export class MediaGridResponseModel {
    name: string;
    extension: string;
    url: string;
    type: string;
    createdDate: string;
    id: string;
    s3Key: string;
    constructor(data?: Partial<MediaGridResponseModel>) {
        this.name = data?.name ?? '';
        this.extension = data?.extension ?? '';
        this.url = data?.url ?? '';
        this.type = data?.type ?? '';
        this.createdDate = data?.createdDate ?? '';
        this.id = data?.id ?? '';
        this.s3Key = data?.s3Key ?? '';
    }

    static deserializeAPIModel(data: IAPIMediaGridModel): MediaGridResponseModel {
        const partialData: Partial<MediaGridResponseModel> = {
            name: data.name,
            extension: data.extension,
            url: data.url,
            type: data.type,
            createdDate: data.createdDate,
            id: data.id,
            s3Key: data.s3Key,
        };

        return new MediaGridResponseModel(partialData);
    }
}
